export default {
      id: "maps-usage",
      viewBox: "0 0 270.06 267.09",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#maps",
      toString: function () {
        return this.url;
      }
    }